<template>
    <div class="question">
        <div class="container">
            <div class="title">
                <p>{{FAQ.ch}}</p>
                <p>{{FAQ.en}}</p>
                <p></p>
            </div>
            <div class="items">
              <div class="item" v-for="(item, index) in FAQ.items" :key="index">
                <p>{{item.title}}</p>
                <p v-html="item.con"></p>
                <p v-if="item.con2">{{item.con2}}</p>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'HomeQuestion',
  setup () {
    // 常见问题
    const FAQ = {
      en: 'FAQ',
      ch: 'Soul广告开户的常见问题',
      items: [
        { title: '1、Soul广告后台地址是什么？', con: 'Soul广告给客户提供的单独的广告投放后台，通过后台可以自定义投放，可以查看详细的投放数据和消耗金额，后台网址为：<a href="https://ad-advertiser.soulapp.cn/login" target="_blank" style="color: #000;text-decoration: revert">https://ad-advertiser.soulapp.cn/login</a>（请认准这个后台地址，以免上当受骗）' },
        { title: '2、Soul广告开户需要什么资质？有哪些行业限制？', con: 'Soul广告平台目前对于客户行业的限制包括二类电商、棋牌捕鱼、黑五类、金融类、竞品（陪玩、社交）、在线试听类、阅读类，对于行业性质不明确的产品客户，可以直接咨询我们的在线客服。对于Soul广告开户所需的资质，需根据不同的行业来确定，需直接联系在线客服进行咨询。' },
        { title: '3、Soul广告的计费方式是怎样的？价格是多少？', con: 'Soul广告平台的广告计费方式以CPC为主，目前最低出价0.1元，实际投放价格需要以后台实际消耗为准。' },
        { title: '4、Soul广告开户有返点政策吗？最低充值金额多少？', con: 'Soul广告开户的返点政策需要联系在线客服，我们会 安排商务人员与您实时确认政策问题。', con2: 'Soul广告后台单次充值金额目前是5000起，后续如果有变化会及时告知大家。' },
        { title: '5、Soul广告投放是否提供广告素材制作和运营优化服务？', con: '目前蜂鸟互动针对Soul广告为广大客户提供免费的广告素材制作以及优化运营服务，而且针对大客户还会提供1V1的专职项目组的对接服务。' }
      ]
    }

    return { FAQ }
  }
}
</script>

<style lang="less" scoped>
.question {
  padding: 40px 24px;
  .title {
    font-size: 30px;
    color: #000;
    p {
      text-align: center;
      &:nth-child(2) {
        margin-top: 1px;
        font-size: 12px;
        color: #222;
      }
      &:last-child {
        width: 50px;
        height: 4px;
        background-color: #cccccc;
        border-radius: 2px;
        margin: 10px auto 20px;
      }
    }
  }
  .items {
    padding: 0 60px;
    .item {
      padding: 15px 0;
      border-bottom: 1px solid #eee;
      &:last-child {
        border-bottom: none;
      }
      p {
        font-size: 18px;
        line-height: 2;
        &:nth-child(2),
        &:last-child {
          color: #ff9933;
          text-indent: 2em;
        }
      }
    }
  }
}
</style>
